import { toast, toastI18n } from "@/components/common/Toast";
import { request } from "@/utils/api/legacyRequest";
import { doRedirect } from "../metadata/metadataActions";

export function sendResetInstructionsToEmail(email) {
  return (dispatch) => {
    dispatch(toast.hide());

    const forgotPasswordFormValues = email;
    const forgotPwURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/public/forgot-password`;
    const payload = {
      forgot_password: {
        email_address: forgotPasswordFormValues,
      },
    };
    request(forgotPwURL, null, "POST", payload)
      .then((response) => {
        if (response.data.recovery_email_sent === false) {
          dispatch(toastI18n('error', 'NoAccount'));
        } else {
          dispatch(toastI18n('success', 'CheckYourEmail'));
        }
      })
      .catch((err) => console.error(err));
  };
}

export function createNewPassword(token, password) {
  return (dispatch) => {
    dispatch(toast.hide());

    const resetPwURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/public/reset-password`;
    const payload = {
      token,
      user: {
        password,
      },
    };
    request(resetPwURL, null, "POST", payload)
      .then(() => {
        dispatch(toastI18n('success', 'PasswordReset'));
        dispatch(doRedirect("/"));
        dispatch(doRedirect("/auth/login"));
      })
      .catch((err) => {
        console.error(err);
        dispatch(toastI18n('error', 'InvalidToken'));
      });
  };
}
